import Vue from 'vue'
import Router from 'vue-router'

import ProductList from '@/components/shopCategory/productsList'
import ProductDetail from '@/components/shopCategory/productDetail'

Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '/',
      name: 'ProductList',
      component: ProductList
    },
    {
      path: '/product/:staticUrl',
      name: 'ProductDetail',
      props: true,
      component: ProductDetail
    }
  ]
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js